import { SxProps, Theme } from '@mui/material';
import Box from '@mui/material/Box';

interface TabPanelProps {
	children?: React.ReactNode;
	index: number;
	value: number;
	/** Extra sx applied to the absolute-fill inner panel. */
	sx?: SxProps<Theme>;
}

export default function CustomTabPanel({ children, value, index, sx, ...other }: TabPanelProps) {
	return (
		<Box
			role="tabpanel"
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			aria-hidden={value !== index}
			sx={{ position: 'absolute', inset: 0, overflowY: 'auto', p: 1, ...(value !== index ? { display: 'none' } : {}), ...sx }}
			{...other}
		>
			{children}
		</Box>
	);
}
